import FieldSelect from "./fieldSelect"

export default (p) => {
    let options = []
    for ( let i = p.min ; i <= p.max ; i++ ) {
        options.push({label:''+i,value:i})
    }
    return <FieldSelect field={p.field} container={p.container} label={p.label}
        options={ options }
    />
}
